/**
 * TransactionTypeService
 * Service for TransactionType entity operations
 * Route: api/transaction-types
 * Controller: TransactionTypesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * TransactionTypeService
 * Handles transaction type CRUD operations and lookups
 */
export class TransactionTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TransactionTypeService.DEFAULT_SERVICE_PATH,
            basePath: TransactionTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== ACTIVE TYPES ====================
    /**
     * Get active transaction types
     * GET /api/transaction-types/active
     * @returns Array of active transaction types
     */
    async getActive() {
        const response = await this.getActiveRaw();
        return response.data ?? [];
    }
    /**
     * Get active transaction types (raw)
     * @returns ResponseData with active transaction types
     */
    getActiveRaw() {
        const endpoint = this.getEndpoint('active', 'active');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
TransactionTypeService.DEFAULT_SERVICE_PATH = 'products';
TransactionTypeService.BASE_PATH = 'api/transaction-types';
//# sourceMappingURL=TransactionTypeService.js.map